/**
 * Consent gate for the cart checkout button.
 *
 * ZMIANA 2026-09-23: przycisk "Zamawiam i płacę" NIE jest już wyłączany.
 * Zgoda na Regulamin nadal jest wymagana, ale egzekwujemy ją przy kliknięciu:
 * bez zaznaczenia pokazujemy komunikat i przewijamy do checkboxa.
 * Powód: szary, nieaktywny przycisk (na mobile dodatkowo pod zgięciem) wyglądał
 * jak zepsuty koszyk — mobile: 7 dodań do koszyka, 0 przejść do checkoutu (30.08–23.09).
 *
 * Binding stays idempotent — the cart re-renders its footer over AJAX, so we
 * re-wire on refresh without stacking listeners.
 */
(function () {
  var BOUND = 'faloTermsBound';
 
  function block(checkbox, error, event) {
    if (event) event.preventDefault();
    if (error) {
      error.hidden = false;
      error.setAttribute('role', 'alert');
    }
    var target = checkbox.closest('.falo-terms') || checkbox;
    target.classList.add('falo-terms--attention');
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try {
      checkbox.focus({ preventScroll: true });
    } catch (e) {
      checkbox.focus();
    }
  }
 
  function wire(root) {
    var checkbox = root.querySelector('[data-falo-terms-checkbox]');
    var error = root.querySelector('[data-falo-terms-error]');
    var button = root.querySelector('#checkout, [name="checkout"]');
    if (!checkbox || !button) return;
 
    if (!checkbox.dataset[BOUND]) {
      checkbox.dataset[BOUND] = '1';
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) {
          if (error) error.hidden = true;
          var wrap = checkbox.closest('.falo-terms');
          if (wrap) wrap.classList.remove('falo-terms--attention');
        }
      });
    }
 
    if (!button.dataset[BOUND]) {
      button.dataset[BOUND] = '1';
      button.addEventListener('click', function (event) {
        // Query fresh: the footer may have been re-rendered since binding.
        var box = document.querySelector('[data-falo-terms-checkbox]');
        if (!box || box.checked) return;
        block(box, document.querySelector('[data-falo-terms-error]'), event);
      });
    }
 
    // Enter in the cart form (e.g. in the note field) submits too.
    var form = document.getElementById('cart');
    if (form && !form.dataset[BOUND]) {
      form.dataset[BOUND] = '1';
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        var isCheckout = submitter ? submitter.name === 'checkout' : true;
        var box = document.querySelector('[data-falo-terms-checkbox]');
        if (isCheckout && box && !box.checked) {
          block(box, document.querySelector('[data-falo-terms-error]'), event);
        }
      });
    }
  }
 
  function init() {
    if (document.querySelector('.falo-terms')) wire(document);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  document.addEventListener('cart:refresh', init);
  document.addEventListener('cart-update', init);
})();